export function applicationPath(schoolId: number) {
  return `/application/${schoolId}`
}
